import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  FaUserCircle,
  FaUserCheck,
  FaUsers,
  FaUserTie,
  FaHandshake,
  FaProjectDiagram,
  FaUsersCog,
  FaTasks,
  FaCheckCircle,
  FaBuilding,
  FaMoneyBillWave,
  FaGift,
    FaHome,        // 👈 YE ADD KARO
  FaIdBadge,     // 👈 YE ADD KARO
} from "react-icons/fa";
import { MdSettings, MdAssignmentTurnedIn } from "react-icons/md";
import { PiListNumbersFill } from "react-icons/pi";
import { RiCloseCircleLine, RiHandCoinLine } from "react-icons/ri";
import { HiMiniCubeTransparent } from "react-icons/hi2";
import { GoProjectSymlink } from "react-icons/go";
import { SiPlotly } from "react-icons/si";
import { useNavigate } from "react-router-dom";
import { GrChannel } from "react-icons/gr";
import { Row, Col, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Dashboard.scss";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import Endimage from "../assets/images/end.png";
import Start from "../assets/images/start.png";
import { TbReceiptRupee } from "react-icons/tb";
import { CiLineHeight } from "react-icons/ci";
import { BiSolidBuildingHouse } from "react-icons/bi";
import runningHourse from "../assets/images/hourse.gif";
import welcomeImg from "../assets/images/bonus.webp";
import bimaActiveImg from "../assets/images/bima.png";
import bimaSuccessImg from "../assets/images/claimed.webp";
import moment from "moment";

/* ═══════════════════════════════════════════════════════════
   STATIC FALLBACK DATA — Agar API se null/empty aaye
   ═══════════════════════════════════════════════════════════ */

const STATIC_SELF_GIFTS = [
  {
    id: 1,
    gift_type: "self",
    offer_name: "Welcome Gift",
    offer_item: "Smart Watch",
    offer_project_name: "A2 Demo Project 1",
    unit: 5,
    smallunit: null,
    area_sqyd: null,
    status: "Eligible",
    achieved_unit: 5,
    achieved_smallunit: null,
    achieved_area_sqyd: null,
    item_amount: 5000,
    date_from: "2026-01-01",
    date_to: "2026-06-30",
    terms_conditions: "Achieve 5 units to unlock this gift.",
  },
  {
    id: 2,
    gift_type: "self",
    offer_name: "Silver Gift",
    offer_item: "Wireless Earbuds",
    offer_project_name: "A2 Demo Project 2",
    unit: 10,
    smallunit: null,
    area_sqyd: null,
    status: "Pending",
    achieved_unit: 6,
    achieved_smallunit: null,
    achieved_area_sqyd: null,
    item_amount: 8000,
    date_from: "2026-01-01",
    date_to: "2026-06-30",
    terms_conditions: "Achieve 10 units to unlock this gift.",
  },
  {
    id: 3,
    gift_type: "self",
    offer_name: "Gold Gift",
    offer_item: "Smartphone",
    offer_project_name: "A2 Demo Project 3",
    unit: 20,
    smallunit: null,
    area_sqyd: null,
    status: "Pending",
    achieved_unit: 8,
    achieved_smallunit: null,
    achieved_area_sqyd: null,
    item_amount: 25000,
    date_from: "2026-01-01",
    date_to: "2026-06-30",
    terms_conditions: "Achieve 20 units to unlock this gift.",
  },
];

const STATIC_TEAM_GIFTS = [
  {
    reward_id: 1,
    reward_name: "Team Reward 1",
    reward_details: {
      offer_item: "Dinner Set",
      terms_conditions: "Team must achieve 100 SQYD.",
      item_amount: 3000,
      date_from: "2026-01-01",
      date_to: "2026-06-30",
      applicable_projects: "A2 Demo Project 1",
      distribution_rule: "30% Top Leg + 30% Second Leg + 40% Self",
    },
    required_area: 100,
    achieved: false,
    total_progress: { achieved: 45, required: 100 },
    legs_progress: {
      leg1: { required: 30, achieved: 15 },
      leg2: { required: 30, achieved: 20 },
      leg3: { required: 40, achieved: 10 },
    },
  },
  {
    reward_id: 2,
    reward_name: "Team Reward 2",
    reward_details: {
      offer_item: "LED TV",
      terms_conditions: "Team must achieve 300 SQYD.",
      item_amount: 25000,
      date_from: "2026-01-01",
      date_to: "2026-06-30",
      applicable_projects: "A2 Demo Project 2",
      distribution_rule: "30% Top Leg + 30% Second Leg + 40% Self",
    },
    required_area: 300,
    achieved: false,
    total_progress: { achieved: 120, required: 300 },
    legs_progress: {
      leg1: { required: 90, achieved: 40 },
      leg2: { required: 90, achieved: 50 },
      leg3: { required: 120, achieved: 30 },
    },
  },
];

const STATIC_LIFETIME_REWARDS = [
  {
    reward_name: "Bronze Lifetime Reward",
    reward_type: "bronze",
    reward_details: {
      offer_item: "Gold Coin",
      terms_conditions: "Lifetime achievement of 500 SQYD.",
      item_amount: 15000,
    },
    total_progress: { required: 500, achieved: 180 },
    achieved: false,
    legs_progress: {
      leg1: { required: 150, achieved: 60, remaining: 90 },
      leg2: { required: 150, achieved: 80, remaining: 70 },
      self_and_other_legs: { required: 200, achieved: 40, remaining: 160 },
    },
  },
  {
    reward_name: "Silver Lifetime Reward",
    reward_type: "silver",
    reward_details: {
      offer_item: "International Trip",
      terms_conditions: "Lifetime achievement of 1500 SQYD.",
      item_amount: 75000,
    },
    total_progress: { required: 1500, achieved: 180 },
    achieved: false,
    legs_progress: {
      leg1: { required: 450, achieved: 60, remaining: 390 },
      leg2: { required: 450, achieved: 80, remaining: 370 },
      self_and_other_legs: { required: 600, achieved: 40, remaining: 560 },
    },
  },
];

const STATIC_ROYALTY_REWARDS = [
  {
    reward_id: 1,
    reward_type: "royalty_star",
    reward_name: "Star Royalty",
    reward_details: {
      offer_item: "Foreign Trip",
      item_amount: 100000,
    },
    total_progress: { required: 1000, achieved: 350 },
    achieved: false,
    legs_progress: {
      leg1: { required: 300, achieved: 120, remaining: 180 },
      leg2: { required: 300, achieved: 140, remaining: 160 },
      self_and_other_legs: { required: 400, achieved: 90, remaining: 310 },
    },
    terms: "Leg matrix distributions apply (30:30:40)",
  },
  {
    reward_id: 2,
    reward_type: "royalty_diamond",
    reward_name: "Diamond Royalty",
    reward_details: {
      offer_item: "Luxury Car",
      item_amount: 500000,
    },
    total_progress: { required: 5000, achieved: 350 },
    achieved: false,
    legs_progress: {
      leg1: { required: 1500, achieved: 120, remaining: 1380 },
      leg2: { required: 1500, achieved: 140, remaining: 1360 },
      self_and_other_legs: { required: 2000, achieved: 90, remaining: 1910 },
    },
    terms: "Leg matrix distributions apply (30:30:40)",
  },
];

/* ═══════════════════════════════════════════════════════════
   ICON MAP
   ═══════════════════════════════════════════════════════════ */
const iconMap = {
  BiSolidBuildingHouse,
  CiLineHeight,
  FaUserCircle,
  FaUserCheck,
  MdSettings,
  FaUsers,
  FaUserTie,
  FaHandshake,
  FaProjectDiagram,
  FaUsersCog,
  FaTasks,
  FaCheckCircle,
  FaBuilding,
  FaMoneyBillWave,
  MdAssignmentTurnedIn,
  HiMiniCubeTransparent,
  PiListNumbersFill,
  RiCloseCircleLine,
  GoProjectSymlink,
  SiPlotly,
  GrChannel,
  TbReceiptRupee,
  RiHandCoinLine,
  FaGift,
};

const API_URL = process.env.REACT_APP_API_URL;
const imageSlider = `${process.env.REACT_APP_IMAGE_API_URL}/uploads/banner/`;

const Dashboard = ({ userType }) => {
  const [eligibilityData, setEligibilityData] = useState([]);
  const [teameligibilityData, setteamEligibilityData] = useState([]);
  const [TeamAchievedTeamArea, setAchievedTeamArea] = useState(0);
  const [lifetimeRewardsList, setLifetimeRewardsList] = useState([]);
  const [lifetimeEligibilityData, setLifetimeEligibilityData] = useState([]);
  const [loadingLifetimeRewards, setLoadingLifetimeRewards] = useState(false);
  const [royaltyRewardsList, setRoyaltyRewardsList] = useState([]);
  const [royaltyEligibilityData, setRoyaltyEligibilityData] = useState([]);
  const [loadingRoyaltyRewards, setLoadingRoyaltyRewards] = useState(false);
  const [loadingRoyaltyEligibility, setLoadingRoyaltyEligibility] =
    useState(false);
  const [loadingLifetimeEligibility, setLoadingLifetimeEligibility] =
    useState(false);
  const [designation, setDesignation] = useState("");
  const [lineData, setLineData] = useState({
    line1: { total_buysqft: 0, total_members: 0, line_name: "" },
    line2: { total_buysqft: 0, total_members: 0, line_name: "" },
    line3: { self_buysqft: 0, total_members: 0, line_name: "" },
    summary: { total_buysqft: 0, total_members: 0, total_lines: 0 },
  });
  const [lineSummary, setLineSummary] = useState({
    first_line: 0,
    second_line: 0,
    third_line: 0,
  });
  const [giftList, setGiftList] = useState([]);
  const [giftTeamList, setGiftTeamList] = useState([]);
  const [loadingGifts, setLoadingGifts] = useState(false);
  const [loadingTeamGifts, setLoadingTeamGifts] = useState(false);
  const [achievedArea, setAchievedArea] = useState(0);
  const [showSlider, setShowSlider] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderImages, setSliderImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagePath, setImagePath] = useState(null);

  const [associateData, setAssociateData] = useState({
    registrationDate: "2026-04-01",
    name: "",
    mobile: "",
    designation: "",
  });

  const [dashboard, setDashboard] = useState({
    todayAssociate: 0,
    todayChannel: 0,
    activeProject: 0,
    activeBlock: 0,
    activePlot: 0,
    totalAssociate: 0,
    totalChannel: 0,
    totalTeamCount: 0,
    total_property: 0,
    total_lead_loan: 0,
    ongoingProject: 0,
    completeProject: 0,
    total_sqyd_self_sales: 0,
    total_sqyd_team_sales: 0,
    total_sqyd_channel_sales: 0,
    total_self_sales_earning: 0,
    total_team_sales_earning: 0,
    total_channel_sales_earning: 0,
    total_loan_earning: 0,
    total_achieved_buy_sqrt: 0,
    total_propertyEarning: 0,
    bimaStatus: {
      activeStatus: false,
      successStatus: false,
    },
    bonus: {
      status: false,
      lastDate: "--",
      joiningDate: "--",
      leadDate: "--",
      targetDate: "--",
      approved: false,
    },
  });

  const navigate = useNavigate();

  const NoDataMessage = ({ message = "Sorry, no data found" }) => (
    <div className="text-center py-4 text-muted">
      <div className="no-data-icon mb-2">
        <RiCloseCircleLine size={40} className="text-secondary" />
      </div>
      <p className="mb-0">{message}</p>
    </div>
  );

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatShortDate = (date) => {
    if (!date) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const calculateDates = () => {
    if (!associateData.registrationDate)
      return { bookingDate: null, closingDate: null };
    const regDate = new Date(associateData.registrationDate);
    const bookingDate = new Date(regDate);
    bookingDate.setDate(regDate.getDate() + 30);
    const closingDate = new Date(bookingDate);
    closingDate.setDate(bookingDate.getDate() + 30);
    return { bookingDate, closingDate };
  };

  const getAuthToken = useCallback(() => localStorage.getItem("token"), []);

  const fetchDashboardData = useCallback(async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/front-dashboard`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.status === "1") {
        setDashboard({
          todayAssociate: data.todayAssociate?.[0]?.total || 0,
          todayChannel: data.todayChannel?.[0]?.total || 0,
          activeProject:
            data.ActiveProject?.[0]?.total ||
            data.activeProject?.[0]?.total ||
            0,
          activeBlock:
            data.Activeblock?.[0]?.total || data.activeBlock?.[0]?.total || 0,
          activePlot:
            data.ActivePlot?.[0]?.total || data.activePlot?.[0]?.total || 0,
          totalAssociate: data.totalAssociate?.[0]?.total || 0,
          totalChannel: data.totalChannel?.[0]?.total || 0,
          totalTeamCount: data.totalTeamCount?.[0]?.total || 0,
          total_property: data.total_property?.[0]?.total || 0,
          total_lead_loan: data.total_lead_loan?.[0]?.total || 0,
          ongoingProject: data.ongoingProject?.[0]?.total || 0,
          completeProject: data.completeProject?.[0]?.total || 0,
          total_sqyd_self_sales: data.total_sqyd_self_sales?.[0]?.total || 0,
          total_sqyd_team_sales: data.total_sqyd_team_sales?.[0]?.total || 0,
          total_sqyd_channel_sales:
            data.total_sqyd_channel_sales?.[0]?.total || 0,
          total_self_sales_earning: parseFloat(
            data.total_self_sales_earning?.[0]?.total || 0,
          ),
          total_team_sales_earning: parseFloat(
            data.total_team_sales_earning?.[0]?.total || 0,
          ),
          total_channel_sales_earning: parseFloat(
            data.total_channel_sales_earning?.[0]?.total || 0,
          ),
          total_loan_earning: parseFloat(
            data.total_loan_earning?.[0]?.total || 0,
          ),
          total_achieved_buy_sqrt: parseFloat(
            data.total_achieved_buy_sqrt?.[0]?.total || 0,
          ),
          total_propertyEarning: parseFloat(
            data.total_propertyEarning?.[0]?.total || 0,
          ),
          bimaStatus: data.bimaStatus || {
            activeStatus: false,
            successStatus: false,
          },
          bonus: {
            status: data.bonus?.status || false,
            joiningDate: data.bonus?.joiningDate || "--",
            lastDate: data.bonus?.lastDate || "--",
            leadDate: data.bonus?.leadDate || "--",
            targetDate: data.bonus?.targetDate || "--",
            approveDate: data.bonus?.approveDate || "--",
            approved: data.bonus?.approved || false,
          },
        });
      }
    } catch (error) {
      console.error("Dashboard fetch error:", error);
    }
  }, [getAuthToken]);

  const fetchLifetimeRewardsList = useCallback(async () => {
    try {
      setLoadingLifetimeRewards(true);
      const token = getAuthToken();
      const response = await fetch(
        `${API_URL}/lifetime-rewards-list-associate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      if (data.success === "1" && data.data && data.data.length > 0) {
        const sortedRewards = [...data.data].sort(
          (a, b) => parseFloat(a.area_sqyd) - parseFloat(b.area_sqyd),
        );
        setLifetimeRewardsList(sortedRewards);
      } else {
        setLifetimeRewardsList([]);
      }
    } catch (error) {
      console.error("Lifetime Rewards list fetch error:", error);
      setLifetimeRewardsList([]);
    } finally {
      setLoadingLifetimeRewards(false);
    }
  }, [getAuthToken]);

  const fetchLifetimeRewardsEligibility = useCallback(async () => {
    try {
      setLoadingLifetimeEligibility(true);
      const token = getAuthToken();
      const response = await fetch(
        `${API_URL}/lifetime-rewards-list-associate-eligibility`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      if (data.status === "1" && Array.isArray(data.data)) {
        setLifetimeEligibilityData(data.data);
      } else {
        setLifetimeEligibilityData([]);
      }
    } catch (error) {
      console.error("Lifetime Rewards eligibility fetch error:", error);
      setLifetimeEligibilityData([]);
    } finally {
      setLoadingLifetimeEligibility(false);
    }
  }, [getAuthToken]);

  const fetchRoyaltyRewardsList = useCallback(async () => {
    try {
      setLoadingRoyaltyRewards(true);
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/leadership-reward-list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.success === "1" && data.data && data.data.length > 0) {
        const sortedRewards = [...data.data].sort(
          (a, b) => parseFloat(a.area_sqyd) - parseFloat(b.area_sqyd),
        );
        setRoyaltyRewardsList(sortedRewards);
      } else {
        setRoyaltyRewardsList([]);
      }
    } catch (error) {
      console.error("Royalty Rewards list fetch error:", error);
      setRoyaltyRewardsList([]);
    } finally {
      setLoadingRoyaltyRewards(false);
    }
  }, [getAuthToken]);

  const fetchRoyaltyRewardsEligibility = useCallback(async () => {
    try {
      setLoadingRoyaltyEligibility(true);
      const token = getAuthToken();
      const response = await fetch(
        `${API_URL}/royalty-rewards-eligibility-associate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      if (data.status === "1" && data.data && data.data.length > 0) {
        setRoyaltyEligibilityData(data.data);
      } else {
        setRoyaltyEligibilityData([]);
      }
    } catch (error) {
      console.error("Royalty eligibility error:", error);
      setRoyaltyEligibilityData([]);
    } finally {
      setLoadingRoyaltyEligibility(false);
    }
  }, [getAuthToken]);

  const fetchGiftList = useCallback(async () => {
    try {
      setLoadingGifts(true);
      const token = getAuthToken();

      const [giftListResponse, eligibilityResponse] = await Promise.all([
        fetch(`${API_URL}/assiciate-gift-current-eligibility`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        fetch(`${API_URL}/assiciate-gift-eligibility`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      const giftListData = await giftListResponse.json();
      const eligibilityData = await eligibilityResponse.json();

      console.log("Gift List Data:", giftListData);

      const eligibleGiftIds = new Set();
      if (eligibilityData.success === true && eligibilityData.data) {
        eligibilityData.data.forEach((project) => {
          if (project.gifts && project.gifts.length > 0) {
            project.gifts.forEach((gift) => {
              if (gift.status === "Eligible") {
                eligibleGiftIds.add(gift.id);
              }
            });
          }
        });
      }

      if (
        giftListData.success === true &&
        giftListData.data &&
        giftListData.data.length > 0
      ) {
        const mergedGifts = giftListData.data.map((gift) => {
          const isEligible = eligibleGiftIds.has(gift.id);
          let eligibilityDetails = null;
          if (isEligible && eligibilityData.data) {
            for (const project of eligibilityData.data) {
              if (project.gifts) {
                const matchingGift = project.gifts.find(
                  (g) => g.id === gift.id,
                );
                if (matchingGift) {
                  eligibilityDetails = matchingGift;
                  break;
                }
              }
            }
          }

          return {
            ...gift,
            status: isEligible ? "Eligible" : "Pending",
            achieved_unit: eligibilityDetails?.achieved_unit || null,
            achieved_smallunit: eligibilityDetails?.achieved_smallunit || null,
            achieved_area_sqyd: eligibilityDetails?.achieved_area_sqyd || null,
            qualifying_leads: eligibilityDetails?.qualifying_leads || [],
            closing_date: eligibilityDetails?.closing_date || null,
          };
        });

        const sortedGifts = mergedGifts.sort((a, b) => {
          const getRequirement = (gift) => {
            if (
              gift.unit !== null &&
              gift.unit !== undefined &&
              gift.unit !== ""
            ) {
              return parseFloat(gift.unit) || 0;
            }
            if (
              gift.smallunit !== null &&
              gift.smallunit !== undefined &&
              gift.smallunit !== ""
            ) {
              return parseFloat(gift.smallunit) || 0;
            }
            return parseFloat(gift.area_sqyd) || 0;
          };
          return getRequirement(a) - getRequirement(b);
        });

        setGiftList(sortedGifts);
      } else {
        setGiftList([]);
      }
    } catch (error) {
      console.error("Gift list fetch error:", error);
      setGiftList([]);
    } finally {
      setLoadingGifts(false);
    }
  }, [getAuthToken]);

  const fetchTeamGiftList = useCallback(async () => {
    try {
      setLoadingTeamGifts(true);
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/team-gift-current-list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.success === "1" && data.data && data.data.length > 0) {
        const sortedGifts = [...data.data].sort(
          (a, b) => parseFloat(a.area_sqyd || 0) - parseFloat(b.area_sqyd || 0),
        );
        setGiftTeamList(sortedGifts);
      } else {
        setGiftTeamList([]);
      }
    } catch (error) {
      console.error("Team gift list fetch error:", error);
      setGiftTeamList([]);
    } finally {
      setLoadingTeamGifts(false);
    }
  }, [getAuthToken]);

  const fetchmyteamLinesSummaryAssociate = useCallback(async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(
        `${API_URL}/myteam-lines-summary-associate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      if (data.status === 1) {
        const newLineData = {
          line1: {
            total_buysqft: parseFloat(data.lines?.line1?.total_buysqft) || 0,
            total_members: 1,
            line_name: data.lines?.line1?.line_name || "Line 1",
            line_id: data.lines?.line1?.line_id,
          },
          line2: {
            total_buysqft: parseFloat(data.lines?.line2?.total_buysqft) || 0,
            total_members: 1,
            line_name: data.lines?.line2?.line_name || "Line 2",
            line_id: data.lines?.line2?.line_id,
          },
          line3: {
            total_buysqft: parseFloat(data.lines?.others?.total_buysqft) || 0,
            self_buysqft: parseFloat(data.lines?.others?.self_buysqft) || 0,
            total_members: data.lines?.others?.lines_count || 0,
            line_name: "Others",
          },
          summary: {
            total_buysqft: parseFloat(data.summary?.total_team_area) || 0,
            total_members: (data.lines?.others?.lines_count || 0) + 2,
            total_lines: data.summary?.total_direct_lines || 0,
          },
        };

        setLineData(newLineData);
        setLineSummary({
          first_line: newLineData.line1.total_buysqft || 0,
          second_line: newLineData.line2.total_buysqft || 0,
          third_line: newLineData.line3.total_buysqft || 0,
        });
      }
    } catch (error) {
      console.error("Team lines summary error:", error);
    }
  }, [getAuthToken]);

  const fetchAssociateProfile = useCallback(async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.status === "1" && data.data) {
        const registrationDate = data.data.date || data.data.created_at || null;
        setAssociateData({
          registrationDate: registrationDate,
          name: data.data.username || "",
          mobile: data.data.mobile || "",
          designation: data.data.designation || "",
        });
      }
    } catch (error) {
      console.error("Profile fetch error:", error);
    }
  }, [getAuthToken]);

  const fetchTeamEligibilityData = useCallback(async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(
        `${API_URL}/assiciate-team-gift-eligibility`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const result = await response.json();
      if (result.success == true) {
        const data = result.data || [];
        setteamEligibilityData(data);
        if (data && data.length > 0 && data[0]) {
          const area = data[0].total_progress?.achieved || 0;
          setAchievedTeamArea(parseFloat(area) || 0);
        } else {
          setAchievedTeamArea(0);
        }
      } else {
        setteamEligibilityData([]);
        setAchievedTeamArea(0);
      }
    } catch (error) {
      console.error("Team eligibility fetch error:", error);
      setteamEligibilityData([]);
      setAchievedTeamArea(0);
    }
  }, [getAuthToken]);

  const fetchEligibilityData = useCallback(async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/assiciate-gift-eligibility`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      const result = await response.json();
      if (result.success) {
        const data = Array.isArray(result.data) ? result.data : [result.data];
        setEligibilityData(data);
        const eligibleItem = data.find((item) => item.status === "Eligible");
        const area = eligibleItem?.achieved_area || data[0]?.achieved_area || 0;
        setAchievedArea(area);
      } else {
        setEligibilityData([]);
        setAchievedArea(0);
      }
    } catch (error) {
      console.error("Error fetching eligibility:", error);
      setEligibilityData([]);
      setAchievedArea(0);
    }
  }, [getAuthToken]);

  const fetchSliderImages = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(`${API_URL}/slider-list`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.data && data.data.length > 0) {
        setSliderImages(data.data || []);
        setImagePath(data.imagePath || "");
      } else {
        setSliderImages([]);
        setError("No slider images available");
      }
    } catch (err) {
      console.error("Error fetching slider images:", err);
      setError("Failed to load slider images. Please try again later.");
      setSliderImages([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const token = localStorage.getItem("token");
    if (isLoggedIn !== "true" || !token) {
      navigate("/login");
      return;
    }

    const designationData = localStorage.getItem("designation");
    setDesignation(designationData || "");

    const fetchAllData = async () => {
      try {
        await Promise.all([
          fetchDashboardData(),
          fetchGiftList(),
          fetchTeamGiftList(),
          fetchLifetimeRewardsList(),
          fetchLifetimeRewardsEligibility(),
          fetchRoyaltyRewardsList(),
          fetchRoyaltyRewardsEligibility(),
          fetchmyteamLinesSummaryAssociate(),
          fetchAssociateProfile(),
          fetchTeamEligibilityData(),
          fetchEligibilityData(),
          fetchSliderImages(),
        ]);
      } catch (error) {
        console.error("Error fetching all data:", error);
      }
    };

    fetchAllData();

    const abortController = new AbortController();
    return () => {
      abortController.abort();
    };
  }, [
    fetchDashboardData,
    fetchGiftList,
    fetchTeamGiftList,
    fetchLifetimeRewardsList,
    fetchLifetimeRewardsEligibility,
    fetchRoyaltyRewardsList,
    fetchRoyaltyRewardsEligibility,
    fetchmyteamLinesSummaryAssociate,
    fetchAssociateProfile,
    fetchTeamEligibilityData,
    fetchEligibilityData,
    fetchSliderImages,
    navigate,
  ]);

  // ═══════════════════════════════════════════════════════════
  // SLIDER AUTO-PLAY
  // ═══════════════════════════════════════════════════════════
  useEffect(() => {
    if (sliderImages.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [sliderImages.length]);

  // ============== GIFT PROGRESS BAR COMPONENT ==============
  const GiftProgressBar = () => {
    if (loadingGifts) {
      return (
        <div className="gift-progress-loading">
          <div className="gift-spinner" role="status">
            <span className="gift-spinner-text">Loading gifts...</span>
          </div>
          <p className="gift-loading-text">Loading gift progress...</p>
        </div>
      );
    }

    const allGiftList =
      Array.isArray(giftList) && giftList.length > 0
        ? giftList
        : STATIC_SELF_GIFTS;

    const displayGiftList = allGiftList.filter(
      (gift) => String(gift?.gift_type || "").toLowerCase() === "self",
    );

    if (displayGiftList.length === 0) {
      return (
        <div className="gift-progress-wrapper">
          <div className="gift-progress-header">
            <h5 className="gift-progress-title">
              <FaGift className="gift-title-icon" />
              Self Gift Progress
            </h5>
          </div>
          <div className="text-center p-4">
            <p className="mb-0">No self gifts available for this month</p>
          </div>
        </div>
      );
    }

    const getNumber = (value, fallback = 0) => {
      const number = Number(value);
      return Number.isFinite(number) ? number : fallback;
    };

    const formatNumber = (value) => {
      const number = getNumber(value);
      return Number.isInteger(number) ? number : number.toFixed(2);
    };

    const isUnitGift = (gift) => {
      const unit = Number(gift?.unit || gift?.required_unit || 0);
      return unit > 0 && gift?.calculation_type !== "smallunit";
    };

    const isSmallUnitGift = (gift) => {
      const smallUnit = Number(
        gift?.smallunit || gift?.required_smallunit || 0,
      );
      return smallUnit > 0 || gift?.calculation_type === "smallunit";
    };

    const getGiftRequirement = (gift) => {
      if (isSmallUnitGift(gift)) {
        return getNumber(gift?.smallunit || gift?.required_smallunit || 0);
      }
      if (isUnitGift(gift)) {
        return getNumber(gift?.unit || gift?.required_unit || 0);
      }
      return getNumber(gift?.area_sqyd || gift?.required_area_sqyd || 0);
    };

    const getAchievedValue = (gift) => {
      if (isUnitGift(gift)) {
        return getNumber(gift?.achieved_unit || 0);
      }
      if (isSmallUnitGift(gift)) {
        return getNumber(gift?.achieved_smallunit || 0);
      }
      return getNumber(gift?.achieved_area_sqyd || 0);
    };

    const getRequirementLabel = (gift) => {
      const requirement = getGiftRequirement(gift);
      if (isUnitGift(gift)) return `${formatNumber(requirement)} Units`;
      if (isSmallUnitGift(gift))
        return `${formatNumber(requirement)} Small Unit`;
      return `${formatNumber(requirement)} SQYD`;
    };

    const maxValue = Math.max(
      ...displayGiftList.map((gift) => getGiftRequirement(gift)),
      100,
    );

    const eligibleCount = displayGiftList.filter(
      (g) => g?.status === "Eligible",
    ).length;

    return (
      <div className="gift-progress-wrapper self_gift">
        <div className="gift-progress-header">
          <h5 className="gift-progress-title">
            <FaGift className="gift-title-icon" />
            Self Gift Progress
          </h5>

          <div className="mt-2 w-50">
            <Row>
              <Col sm={12} className="mb-3 text-end">
                <div className="fs-5 d-block">Current Eligible</div>
                <span className="text-success">
                  {eligibleCount} / {displayGiftList.length}
                </span>
              </Col>
            </Row>
          </div>
        </div>

        <div className="gift-progress-container">
          <div className="gift-progress-track">
            <div className="gift-progress-line">
              <div className="gift-progress-fill"></div>
            </div>

            <div className="gift-steps-scroll-container">
              <div className="gift-steps-flex-container">
                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Start} alt="Start" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">Start Point</div>
                      <div className="gift-step-target">0</div>
                    </div>
                  </div>
                </div>

                {displayGiftList.map((gift, index) => {
                  const isEligible = gift?.status === "Eligible";
                  const giftRequirement = getGiftRequirement(gift);
                  const requirementLabel = getRequirementLabel(gift);
                  const achievedValue = getAchievedValue(gift);
                  const remaining = Math.max(
                    0,
                    giftRequirement - achievedValue,
                  );

                  const projectName =
                    gift?.offer_project_name || gift?.project_name || "-";
                  const giftName =
                    gift?.offer_name || gift?.gift_name || `Gift ${index + 1}`;
                  const giftItem =
                    gift?.offer_item || gift?.gift_item || "Gift Item";
                  const terms =
                    gift?.terms_conditions || "No terms & conditions";
                  const itemAmount = gift?.item_amount || 0;
                  const dateFrom =
                    gift?.date_from || gift?.gift_date_from || "-";
                  const dateTo = gift?.date_to || gift?.gift_date_to || "-";

                  return (
                    <div
                      key={gift?.id || index}
                      className={`gift-step-flex-item ${isEligible ? "gift-step-completed" : ""}`}
                    >
                      <div className="gift-step-content-wrapper">
                        <div
                          className={`gift-step-marker ovel ${isEligible ? "bg-success" : "bg-warning"}`}
                        >
                          {isEligible ? "✅ Eligible" : "⏳ Pending"}
                        </div>

                        <div className="gift-step-content">
                          <div className="gift-step-name">{giftName}</div>

                          {isSmallUnitGift(gift) && (
                            <div
                              style={{
                                display: "inline-block",
                                marginTop: "5px",
                                padding: "3px 8px",
                                borderRadius: "5px",
                                background: "#fff3cd",
                                color: "#856404",
                                fontSize: "12px",
                                fontWeight: "700",
                              }}
                            >
                              🏡 SMALL UNIT GIFT
                            </div>
                          )}

                          <div className="gift-step-target">{giftItem}</div>

                          <div className="gift-step-target text-dark">
                            <strong>Requirement: {requirementLabel}</strong>
                          </div>

                          {achievedValue > 0 && (
                            <div className="gift-step-target text-success">
                              <strong>
                                Achieved: {formatNumber(achievedValue)}
                              </strong>
                            </div>
                          )}

                          {!isEligible && achievedValue > 0 && (
                            <div className="gift-step-target text-danger">
                              <strong>
                                Need: {formatNumber(remaining)} more
                              </strong>
                            </div>
                          )}

                          <div className="gift-step-target text-muted small">
                            <div>
                              <strong>Project:</strong> {projectName}
                            </div>
                            <div>
                              Date Range: {dateFrom?.split(" ")[0]} to{" "}
                              {dateTo?.split(" ")[0]}
                            </div>

                            <div
                              style={{
                                color:
                                  Number(itemAmount) < 0 ? "red" : "green",
                              }}
                            >
                              Amount: ₹{Number(itemAmount).toLocaleString()}
                            </div>
                          </div>

                          <div className="gift-step-target gift_content">
                            {terms}
                            {isEligible && (
                              <div
                                style={{
                                  color: "#198754",
                                  fontWeight: "700",
                                  marginTop: "6px",
                                  fontSize: "13px",
                                  background: "#d1e7dd",
                                  padding: "5px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                🎉 Gift Qualified
                              </div>
                            )}
                            {!isEligible && achievedValue === 0 && (
                              <div
                                style={{
                                  color: "#dc3545",
                                  fontWeight: "700",
                                  marginTop: "6px",
                                  fontSize: "13px",
                                  background: "#f8d7da",
                                  padding: "5px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                ⏳ Not Qualified Yet
                              </div>
                            )}
                            {!isEligible && achievedValue > 0 && (
                              <div
                                style={{
                                  color: "#ffc107",
                                  fontWeight: "700",
                                  marginTop: "6px",
                                  fontSize: "13px",
                                  background: "#fff3cd",
                                  padding: "5px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                ⏳ In Progress ({formatNumber(achievedValue)} /{" "}
                                {formatNumber(giftRequirement)})
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Endimage} alt="End" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">End Point</div>
                      <div className="gift-step-target">
                        {formatNumber(maxValue)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table bordered hover responsive className="mt-3">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Gift Name</th>
              <th>Gift Item</th>
              <th>Requirement</th>
              <th>Achieved</th>
              <th>Remaining</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Project</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {displayGiftList.map((gift, index) => {
              const isEligible = gift?.status === "Eligible";
              const giftRequirement = getGiftRequirement(gift);
              const achievedValue = getAchievedValue(gift);
              const remaining = Math.max(0, giftRequirement - achievedValue);
              const requirementLabel = getRequirementLabel(gift);
              const projectName =
                gift?.offer_project_name || gift?.project_name || "-";
              const giftName = gift?.offer_name || gift?.gift_name || "-";
              const giftItem = gift?.offer_item || gift?.gift_item || "-";
              const dateFrom = gift?.date_from || gift?.gift_date_from || "-";
              const dateTo = gift?.date_to || gift?.gift_date_to || "-";

              return (
                <tr
                  key={gift?.id || index}
                  className={isEligible ? "table-success" : ""}
                >
                  <td>{index + 1}</td>
                  <td>
                    <strong
                      style={
                        isEligible
                          ? { color: "#198754", fontWeight: "700" }
                          : {}
                      }
                    >
                      {giftName}
                    </strong>
                  </td>
                  <td>{giftItem}</td>
                  <td>{requirementLabel}</td>
                  <td>{formatNumber(achievedValue)}</td>
                  <td
                    style={{
                      color: remaining > 0 ? "#dc3545" : "#198754",
                      fontWeight: "bold",
                    }}
                  >
                    {formatNumber(remaining)}
                  </td>
                  <td className="text-danger">{dateFrom}</td>
                  <td className="text-success">{dateTo}</td>
                  <td>{projectName}</td>
                  <td>
                    <span
                      style={{
                        color: isEligible ? "#198754" : "#ffc107",
                        fontWeight: "bold",
                        background: isEligible ? "#d1e7dd" : "#fff3cd",
                        padding: "3px 8px",
                        borderRadius: "4px",
                        display: "inline-block",
                      }}
                    >
                      {isEligible ? "✅ Eligible" : "⏳ Pending"}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  // ============== TEAM PROGRESS BAR COMPONENT ==============
  const TeamProgressBar = () => {
    if (loadingTeamGifts) {
      return (
        <div className="gift-progress-loading">
          <div className="gift-spinner" role="status">
            <span className="gift-spinner-text">Loading team gifts...</span>
          </div>
          <p className="gift-loading-text">Loading team gift progress...</p>
        </div>
      );
    }

    const teamGiftData = Array.isArray(teameligibilityData)
      ? teameligibilityData
      : [];

    const displayGiftTeamList = teamGiftData.filter(
      (gift) => String(gift?.gift_type || "").toLowerCase() === "team",
    );

    let finalGiftList =
      displayGiftTeamList.length > 0 ? displayGiftTeamList : giftTeamList;

    if (finalGiftList.length === 0) {
      finalGiftList = STATIC_TEAM_GIFTS;
    }

    if (finalGiftList.length === 0) {
      return (
        <div className="gift-progress-wrapper">
          <div className="gift-progress-header">
            <h5 className="gift-progress-title">
              <FaUsers className="gift-title-icon" />
              Team Gift Progress
            </h5>
          </div>
          <div className="text-center p-4">
            <p className="mb-0">No team gifts available for this month</p>
          </div>
        </div>
      );
    }

    const getNumber = (value, fallback = 0) => {
      const number = Number(value);
      return Number.isFinite(number) ? number : fallback;
    };

    const formatNumber = (value) => {
      const number = getNumber(value);
      return Number.isInteger(number) ? number : number.toFixed(2);
    };

    const getGiftRequirement = (gift) => {
      return getNumber(gift?.required_area || gift?.area_sqyd || 0);
    };

    const getAchievedValue = (gift) => {
      return getNumber(gift?.total_progress?.achieved || 0);
    };

    const getRequirementLabel = (gift) => {
      const requirement = getGiftRequirement(gift);
      return `${formatNumber(requirement)} SQYD`;
    };

    const maxValue = Math.max(
      ...finalGiftList.map((gift) => getGiftRequirement(gift)),
      100,
    );

    const eligibleCount = finalGiftList.filter(
      (g) => g?.achieved === true,
    ).length;

    return (
      <div className="gift-progress-wrapper team_gift">
        <div className="gift-progress-header">
          <h5 className="gift-progress-title">
            <FaUsers className="gift-title-icon" />
            Team Gift Progress
          </h5>

          <div className="mt-2 w-50">
            <Row>
              <Col sm={12} className="mb-3 text-end">
                <div className="fs-5 d-block">Current Eligible</div>
                <span className="text-success">
                  {eligibleCount} / {finalGiftList.length}
                </span>
              </Col>
            </Row>
          </div>
        </div>

        <div className="gift-progress-container">
          <div className="gift-progress-track">
            <div className="gift-progress-line">
              <div className="gift-progress-fill"></div>
            </div>

            <div className="gift-steps-scroll-container">
              <div className="gift-steps-flex-container">
                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Start} alt="Start" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">Start Point</div>
                      <div className="gift-step-target">0 SQYD</div>
                    </div>
                  </div>
                </div>

                {finalGiftList.map((gift, index) => {
                  const isEligible = gift?.achieved === true;
                  const giftRequirement = getGiftRequirement(gift);
                  const requirementLabel = getRequirementLabel(gift);
                  const achievedValue = getAchievedValue(gift);
                  const remaining = Math.max(
                    0,
                    giftRequirement - achievedValue,
                  );

                  const giftName =
                    gift?.reward_name ||
                    gift?.offer_name ||
                    `Gift ${index + 1}`;
                  const giftItem =
                    gift?.reward_details?.offer_item ||
                    gift?.offer_item ||
                    "Gift Item";
                  const terms =
                    gift?.reward_details?.terms_conditions ||
                    gift?.terms_conditions ||
                    "No terms & conditions";
                  const itemAmount =
                    gift?.reward_details?.item_amount || gift?.item_amount || 0;
                  const dateFrom =
                    gift?.reward_details?.date_from || gift?.date_from || "-";
                  const dateTo =
                    gift?.reward_details?.date_to || gift?.date_to || "-";
                  const projectName =
                    gift?.reward_details?.applicable_projects ||
                    gift?.offer_project_name ||
                    "-";
                  const distributionRule =
                    gift?.reward_details?.distribution_rule ||
                    "30% Top Leg + 30% Second Leg + 40% Self + Remaining Legs";

                  const legs = gift?.legs_progress || {};
                  const leg1 = legs?.leg1 || { required: 0, achieved: 0 };
                  const leg2 = legs?.leg2 || { required: 0, achieved: 0 };
                  const leg3 = legs?.leg3 || { required: 0, achieved: 0 };

                  const leg1Met = (leg1.achieved || 0) >= (leg1.required || 0);
                  const leg2Met = (leg2.achieved || 0) >= (leg2.required || 0);
                  const leg3Met = (leg3.achieved || 0) >= (leg3.required || 0);
                  const allLegsMet = leg1Met && leg2Met && leg3Met;

                  const isFullyEligible = isEligible && allLegsMet;

                  return (
                    <div
                      key={gift?.reward_id || gift?.id || index}
                      className={`gift-step-flex-item ${isFullyEligible ? "gift-step-completed" : ""}`}
                    >
                      <div className="gift-step-content-wrapper">
                        <div
                          className={`gift-step-marker ovel ${isFullyEligible ? "bg-success" : "bg-warning"}`}
                        >
                          {isFullyEligible ? "✅ Eligible" : "⏳ Pending"}
                        </div>

                        <div className="gift-step-content">
                          <div className="gift-step-name">{giftName}</div>

                          <div className="gift-step-target">{giftItem}</div>

                          <div className="gift-step-target text-dark">
                            <strong>Requirement: {requirementLabel}</strong>
                          </div>

                          {achievedValue > 0 && (
                            <div className="gift-step-target text-success">
                              <strong>
                                Achieved: {formatNumber(achievedValue)}
                              </strong>
                            </div>
                          )}

                          {!isFullyEligible && achievedValue > 0 && (
                            <div className="gift-step-target text-danger">
                              <strong>
                                Need: {formatNumber(remaining)} more
                              </strong>
                            </div>
                          )}

                          <div className="gift-step-target text-muted small mt-2">
                            <div>
                              <strong>Distribution:</strong> {distributionRule}
                            </div>
                            <div className="mt-1">
                              <span
                                style={{ color: leg1Met ? "green" : "red" }}
                              >
                                Leg 1: {formatNumber(leg1.achieved)} /{" "}
                                {formatNumber(leg1.required)}
                              </span>
                            </div>
                            <div>
                              <span
                                style={{ color: leg2Met ? "green" : "red" }}
                              >
                                Leg 2: {formatNumber(leg2.achieved)} /{" "}
                                {formatNumber(leg2.required)}
                              </span>
                            </div>
                            <div>
                              <span
                                style={{ color: leg3Met ? "green" : "red" }}
                              >
                                Leg 3: {formatNumber(leg3.achieved)} /{" "}
                                {formatNumber(leg3.required)}
                              </span>
                            </div>
                          </div>

                          <div className="gift-step-target text-muted small">
                            <div>
                              <strong>Project:</strong> {projectName}
                            </div>
                            <div>
                              Date Range: {dateFrom?.split(" ")[0]} to{" "}
                              {dateTo?.split(" ")[0]}
                            </div>

                            <div
                              style={{
                                color:
                                  Number(itemAmount) < 0 ? "red" : "green",
                              }}
                            >
                              Amount: ₹{Number(itemAmount).toLocaleString()}
                            </div>
                          </div>

                          <div className="gift-step-target gift_content">
                            {terms}
                            {isFullyEligible && (
                              <div
                                style={{
                                  color: "#198754",
                                  fontWeight: "700",
                                  marginTop: "6px",
                                  fontSize: "13px",
                                  background: "#d1e7dd",
                                  padding: "5px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                🎉 Gift Qualified
                              </div>
                            )}
                            {!isFullyEligible && achievedValue === 0 && (
                              <div
                                style={{
                                  color: "#dc3545",
                                  fontWeight: "700",
                                  marginTop: "6px",
                                  fontSize: "13px",
                                  background: "#f8d7da",
                                  padding: "5px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                ⏳ Not Qualified Yet
                              </div>
                            )}
                            {!isFullyEligible && achievedValue > 0 && (
                              <div
                                style={{
                                  color: "#ffc107",
                                  fontWeight: "700",
                                  marginTop: "6px",
                                  fontSize: "13px",
                                  background: "#fff3cd",
                                  padding: "5px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                ⏳ In Progress ({formatNumber(achievedValue)} /{" "}
                                {formatNumber(giftRequirement)})
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Endimage} alt="End" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">End Point</div>
                      <div className="gift-step-target">
                        {formatNumber(maxValue)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table bordered hover responsive className="mt-3">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Gift Name</th>
              <th>Gift Item</th>
              <th>Requirement</th>
              <th>Achieved</th>
              <th>Remaining</th>
              <th>Leg 1 (30%)</th>
              <th>Leg 2 (30%)</th>
              <th>Leg 3 (40%)</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Project</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {finalGiftList.map((gift, index) => {
              const isEligible = gift?.achieved === true;
              const giftRequirement = getGiftRequirement(gift);
              const achievedValue = getAchievedValue(gift);
              const remaining = Math.max(0, giftRequirement - achievedValue);
              const requirementLabel = getRequirementLabel(gift);

              const legs = gift?.legs_progress || {};
              const leg1 = legs?.leg1 || { required: 0, achieved: 0 };
              const leg2 = legs?.leg2 || { required: 0, achieved: 0 };
              const leg3 = legs?.leg3 || { required: 0, achieved: 0 };

              const leg1Met = (leg1.achieved || 0) >= (leg1.required || 0);
              const leg2Met = (leg2.achieved || 0) >= (leg2.required || 0);
              const leg3Met = (leg3.achieved || 0) >= (leg3.required || 0);
              const allLegsMet = leg1Met && leg2Met && leg3Met;

              const isFullyEligible = isEligible && allLegsMet;

              const projectName =
                gift?.reward_details?.applicable_projects ||
                gift?.offer_project_name ||
                "-";
              const giftName = gift?.reward_name || gift?.offer_name || "-";
              const giftItem =
                gift?.reward_details?.offer_item || gift?.offer_item || "-";
              const dateFrom =
                gift?.reward_details?.date_from || gift?.date_from || "-";
              const dateTo =
                gift?.reward_details?.date_to || gift?.date_to || "-";

              return (
                <tr
                  key={gift?.reward_id || gift?.id || index}
                  className={isFullyEligible ? "table-success" : ""}
                >
                  <td>{index + 1}</td>
                  <td>
                    <strong
                      style={
                        isFullyEligible
                          ? { color: "#198754", fontWeight: "700" }
                          : {}
                      }
                    >
                      {giftName}
                    </strong>
                  </td>
                  <td>{giftItem}</td>
                  <td>{requirementLabel}</td>
                  <td>{formatNumber(achievedValue)}</td>
                  <td
                    style={{
                      color: remaining > 0 ? "#dc3545" : "#198754",
                      fontWeight: "bold",
                    }}
                  >
                    {formatNumber(remaining)}
                  </td>
                  <td style={{ color: leg1Met ? "green" : "red" }}>
                    {formatNumber(leg1.achieved)} /{" "}
                    {formatNumber(leg1.required)}
                  </td>
                  <td style={{ color: leg2Met ? "green" : "red" }}>
                    {formatNumber(leg2.achieved)} /{" "}
                    {formatNumber(leg2.required)}
                  </td>
                  <td style={{ color: leg3Met ? "green" : "red" }}>
                    {formatNumber(leg3.achieved)} /{" "}
                    {formatNumber(leg3.required)}
                  </td>
                  <td className="text-danger">{dateFrom}</td>
                  <td className="text-success">{dateTo}</td>
                  <td>{projectName}</td>
                  <td>
                    <span
                      style={{
                        color: isFullyEligible ? "#198754" : "#ffc107",
                        fontWeight: "bold",
                        background: isFullyEligible ? "#d1e7dd" : "#fff3cd",
                        padding: "3px 8px",
                        borderRadius: "4px",
                        display: "inline-block",
                      }}
                    >
                      {isFullyEligible ? "✅ Eligible" : "⏳ Pending"}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  // ============== LIFETIME REWARDS PROGRESS BAR ==============
  const LifetimeRewardsProgressBar = () => {
    if (loadingLifetimeEligibility) {
      return (
        <div className="gift-progress-loading">
          <div className="gift-spinner" role="status">
            <span className="gift-spinner-text">
              Loading lifetime Rewards...
            </span>
          </div>
          <p className="gift-loading-text">
            Loading lifetime Rewards progress...
          </p>
        </div>
      );
    }

    // ✅ STATIC FALLBACK
    const displayLifetimeRewardsList =
      lifetimeEligibilityData && lifetimeEligibilityData.length > 0
        ? lifetimeEligibilityData
        : STATIC_LIFETIME_REWARDS;

    const currentSqyd = displayLifetimeRewardsList.reduce(
      (max, item) => Math.max(max, item.total_progress?.achieved || 0),
      0,
    );

    const maxSqyd =
      displayLifetimeRewardsList.length > 0
        ? Math.max(
            ...displayLifetimeRewardsList.map(
              (item) => item.total_progress?.required || 0,
            ),
          )
        : 0;

    return (
      <div className="gift-progress-wrapper">
        <div className="gift-progress-header">
          <h5 className="gift-progress-title">
            <FaGift className="gift-title-icon" />
            Lifetime Rewards Progress
          </h5>

          <div className="mt-2 w-50">
            <Row>
              <Col sm={12} className="mb-3 text-end">
                <div className="fs-5 d-block">Current</div>
                <span className="text-success">
                  {Number(currentSqyd).toFixed(2)} SQYD
                </span>
              </Col>
            </Row>
          </div>
        </div>

        <div className="gift-progress-container life_time_reward">
          <div className="gift-progress-track">
            <div className="gift-progress-line">
              <div className="gift-progress-fill"></div>
            </div>

            <div className="gift-steps-scroll-container">
              <div className="gift-steps-flex-container">
                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Start} alt="Start" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">Start Point</div>
                      <div className="gift-step-target">0 SQYD</div>
                    </div>
                  </div>
                </div>

                {/* ✅ FIXED: displayLifetimeRewardsList use karo, displayList nahi */}
                {displayLifetimeRewardsList.map((reward, index) => {
                  const isEligible = reward.achieved === true;
                  const targetArea = reward.total_progress?.required || 0;
                  const currentArea = reward.total_progress?.achieved || 0;
                  const legs = reward.legs_progress || {};

                  const formattedLegs = [
                    {
                      name: "Leg 1",
                      required: legs.leg1?.required || 0,
                      achieved: legs.leg1?.achieved || 0,
                      remaining:
                        legs.leg1?.remaining ||
                        Math.max(
                          0,
                          (legs.leg1?.required || 0) -
                            (legs.leg1?.achieved || 0),
                        ),
                    },
                    {
                      name: "Leg 2",
                      required: legs.leg2?.required || 0,
                      achieved: legs.leg2?.achieved || 0,
                      remaining:
                        legs.leg2?.remaining ||
                        Math.max(
                          0,
                          (legs.leg2?.required || 0) -
                            (legs.leg2?.achieved || 0),
                        ),
                    },
                    {
                      name: "Leg 3",
                      required: legs.self_and_other_legs?.required || 0,
                      achieved: legs.self_and_other_legs?.achieved || 0,
                      remaining:
                        legs.self_and_other_legs?.remaining ||
                        Math.max(
                          0,
                          (legs.self_and_other_legs?.required || 0) -
                            (legs.self_and_other_legs?.achieved || 0),
                        ),
                    },
                  ];

                  return (
                    <div
                      key={reward.reward_name || index}
                      className={`gift-step-flex-item ${isEligible ? "gift-step-completed" : ""}`}
                    >
                      <div className="gift-step-content-wrapper">
                        {/* Marker on top */}
                        <div
                          className={`gift-step-marker ${isEligible ? "bg-success" : "bg-danger"}`}
                        >
                          {isEligible ? "✓ Eligible" : "✗ Not Eligible"}
                        </div>

                        {/* Card */}
                        <div className="reward-card">
                          {/* Header */}
                          <div className="reward-card-header">
                            <div className="reward-card-name">
                              {reward.reward_name}
                            </div>
                            <div className="reward-card-item">
                              {reward.reward_details?.offer_item || "-"}
                            </div>
                          </div>

                          {/* Progress */}
                          <div className="reward-card-progress">
                            <div className="progress-item">
                              <span className="progress-label">Required</span>
                              <span className="progress-value">
                                {targetArea} SQYD
                              </span>
                            </div>
                            <div className="progress-item">
                              <span className="progress-label">Current</span>
                              <span className="progress-value text-success">
                                {currentArea} SQYD
                              </span>
                            </div>
                          </div>

                          {/* Legs */}
                          <div className="reward-card-legs">
                            {formattedLegs.map((legItem, idx) => {
                              const required = legItem.required || 0;
                              const achieved = legItem.achieved || 0;
                              const remaining = legItem.remaining || 0;
                              const legActive =
                                achieved >= required && required > 0;

                              return (
                                <div key={idx} className="leg-row">
                                  <span className="leg-name">
                                    {legItem.name}
                                  </span>
                                  <span className="leg-values">
                                    <strong>{required.toFixed(0)}</strong> /{" "}
                                    {achieved.toFixed(0)}
                                  </span>
                                  <span
                                    className={`leg-status ${legActive ? "active" : "inactive"}`}
                                  >
                                    {legActive
                                      ? "✓ Met"
                                      : `${remaining.toFixed(0)} left`}
                                  </span>
                                </div>
                              );
                            })}
                          </div>

                          {/* Amount */}
                          {reward.reward_details?.item_amount > 0 && (
                            <div className="reward-card-amount">
                              ₹
                              {Number(
                                reward.reward_details.item_amount,
                              ).toLocaleString()}
                            </div>
                          )}

                          {/* Terms */}
                          {reward.reward_details?.terms_conditions && (
                            <div className="reward-card-terms">
                              {reward.reward_details.terms_conditions}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Endimage} alt="Endimage" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">End Point</div>
                      <div className="gift-step-target">{maxSqyd} SQYD</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table bordered hover responsive className="mt-3">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Reward</th>
              <th>Required SQYD</th>
              <th>Achieved SQYD</th>
              <th>Status</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {displayLifetimeRewardsList.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.reward_name}</td>
                <td>{item.total_progress?.required}</td>
                <td>{item.total_progress?.achieved}</td>
                <td>
                  {item.achieved ? (
                    <span className="text-success">Qualified</span>
                  ) : (
                    <span className="text-danger">Not Qualified</span>
                  )}
                </td>
                <td>
                  ₹
                  {Number(
                    item.reward_details?.item_amount || 0,
                  ).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  // ============== ROYALTY REWARDS PROGRESS BAR ==============
  const RoyaltyRewardsProgressBar = () => {
    if (loadingRoyaltyRewards || loadingRoyaltyEligibility) {
      return (
        <div className="gift-progress-loading">
          <div className="gift-spinner" role="status">
            <span className="gift-spinner-text">
              Loading Royalty Rewards...
            </span>
          </div>
          <p className="gift-loading-text">
            Loading Royalty Rewards progress...
          </p>
        </div>
      );
    }

    // ✅ STATIC FALLBACK
    const displayList =
      royaltyEligibilityData && royaltyEligibilityData.length > 0
        ? royaltyEligibilityData
        : royaltyRewardsList && royaltyRewardsList.length > 0
          ? royaltyRewardsList
          : STATIC_ROYALTY_REWARDS;

    let maxAchievedArea = 0;
    if (displayList.length > 0) {
      maxAchievedArea = displayList.reduce((max, item) => {
        const currentTotal = parseFloat(item.total_progress?.achieved || 0);
        return currentTotal > max ? currentTotal : max;
      }, 0);
    }

    return (
      <div className="gift-progress-wrapper">
        <div className="gift-progress-header">
          <h5 className="gift-progress-title">
            <FaGift className="gift-title-icon" />
            Royalty Rewards Progress
          </h5>
          <div className="mt-2 w-50">
            <Row>
              <Col sm={12} className="mb-3 text-end">
                <div className="fs-5 d-block">Your Total Achieved Area</div>
                <span className="text-success fw-bold fs-4">
                  {maxAchievedArea.toFixed(2)} SQYD
                </span>
              </Col>
            </Row>
          </div>
        </div>

        <div className="gift-progress-container royalty_reward">
          <div className="gift-progress-track">
            <div className="gift-progress-line">
              <div className="gift-progress-fill"></div>
            </div>

            <div className="gift-steps-scroll-container">
              <div className="gift-steps-flex-container">
                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Start} alt="Start" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">Start Point</div>
                      <div className="gift-step-target">0 SQYD</div>
                    </div>
                  </div>
                </div>

                {displayList.map((reward, index) => {
                  const isEligible = reward.achieved === true;
                  const targetArea = reward.total_progress?.required || 0;
                  const currentArea = reward.total_progress?.achieved || 0;
                  const legs = reward.legs_progress || {};

                  const formattedLegs = [
                    {
                      name: "Leg 1 (30%)",
                      required: legs.leg1?.required || 0,
                      achieved: legs.leg1?.achieved || 0,
                    },
                    {
                      name: "Leg 2 (30%)",
                      required: legs.leg2?.required || 0,
                      achieved: legs.leg2?.achieved || 0,
                    },
                    {
                      name: "Leg 3 (40%)",
                      required: legs.self_and_other_legs?.required || 0,
                      achieved: legs.self_and_other_legs?.achieved || 0,
                    },
                  ];

                  return (
                    <div
                      key={reward.reward_type || index}
                      className={`gift-step-flex-item ${isEligible ? "gift-step-completed" : ""}`}
                    >
                      <div className="gift-step-content-wrapper">
                        {/* Marker on top */}
                        <div
                          className={`gift-step-marker ${isEligible ? "bg-success" : "bg-danger"}`}
                        >
                          {isEligible ? "✓ Eligible" : "✗ Not Eligible"}
                        </div>

                        {/* Card */}
                        <div className="reward-card">
                          {/* Header */}
                          <div className="reward-card-header">
                            <div className="reward-card-name">
                              {reward.reward_name || "Royalty Milestone"}
                            </div>
                            <div className="reward-card-item">
                              {reward.reward_details?.offer_item || "-"}
                            </div>
                            <div className="reward-card-type">
                              {reward.reward_type
                                ?.replace(/_/g, " ")
                                .toUpperCase() || "-"}
                            </div>
                          </div>

                          {/* Progress */}
                          <div className="reward-card-progress">
                            <div className="progress-item">
                              <span className="progress-label">Required</span>
                              <span className="progress-value">
                                {targetArea} SQYD
                              </span>
                            </div>
                            <div className="progress-item">
                              <span className="progress-label">Current</span>
                              <span className="progress-value text-success">
                                {currentArea} SQYD
                              </span>
                            </div>
                          </div>

                          {/* Legs */}
                          <div className="reward-card-legs">
                            {formattedLegs.map((legItem, idx) => {
                              const required = legItem.required || 0;
                              const achieved = legItem.achieved || 0;
                              const remaining = Math.max(
                                0,
                                required - achieved,
                              );
                              const legActive =
                                achieved >= required && required > 0;

                              return (
                                <div key={idx} className="leg-row">
                                  <span className="leg-name">
                                    {legItem.name}
                                  </span>
                                  <span className="leg-values">
                                    <strong>{required.toFixed(0)}</strong> /{" "}
                                    {achieved.toFixed(0)}
                                  </span>
                                  <span
                                    className={`leg-status ${legActive ? "active" : "inactive"}`}
                                  >
                                    {legActive
                                      ? "✓ Met"
                                      : `${remaining.toFixed(0)} left`}
                                  </span>
                                </div>
                              );
                            })}
                          </div>

                          {/* Amount */}
                          {reward.reward_details?.item_amount > 0 && (
                            <div className="reward-card-amount">
                              ₹
                              {Number(
                                reward.reward_details.item_amount,
                              ).toLocaleString()}
                            </div>
                          )}

                          {/* Terms */}
                          <div className="reward-card-terms">
                            {reward.terms ||
                              "Leg matrix distributions apply (30:30:40)"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="gift-step-flex-item gift-step-blank">
                  <div className="gift-step-content-wrapper">
                    <div className="gift-step-marker gift-step-marker-blank">
                      <span>
                        <img src={Endimage} alt="Endimage" width="50" />
                      </span>
                    </div>
                    <div className="gift-step-content">
                      <div className="gift-step-name">End Point</div>
                      <div className="gift-step-target">
                        {displayList.length > 0
                          ? `${displayList[displayList.length - 1]?.total_progress?.required || 0} SQYD`
                          : "0 SQYD"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive mt-4">
          <table className="table table-bordered table-hover alignment-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Reward Type</th>
                <th>Reward Name</th>
                <th>Target Area (SQYD)</th>
                <th>Legs Breakdown (Achieved / Required)</th>
                <th>Your Total Progress</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {displayList.map((data, index) => {
                const isEligible = data.achieved === true;
                const legs = data.legs_progress || {};

                const leg1Required = legs.leg1?.required || 0;
                const leg1Achieved = legs.leg1?.achieved || 0;
                const leg2Required = legs.leg2?.required || 0;
                const leg2Achieved = legs.leg2?.achieved || 0;
                const leg3Required = legs.self_and_other_legs?.required || 0;
                const leg3Achieved = legs.self_and_other_legs?.achieved || 0;

                return (
                  <tr key={index} className={isEligible ? "table-success" : ""}>
                    <td>{index + 1}</td>
                    <td className="text-capitalize">
                      {data.reward_type?.replace(/_/g, " ") || "-"}
                    </td>
                    <td className="fw-bold">{data.reward_name || "-"}</td>
                    <td className="text-primary fw-bold">
                      {data.total_progress?.required || 0}
                    </td>
                    <td>
                      <small>
                        L1 (30%): {leg1Achieved}/{leg1Required} | L2 (30%):{" "}
                        {leg2Achieved}/{leg2Required} | L3 (40%): {leg3Achieved}
                        /{leg3Required}
                      </small>
                    </td>
                    <td>
                      <span className="fw-bold text-success">
                        {data.total_progress?.achieved || 0}
                      </span>
                      <span className="text-muted">
                        {" "}
                        / {data.total_progress?.required || 0}
                      </span>
                    </td>
                    <td
                      className={
                        isEligible
                          ? "text-success fw-bold"
                          : "text-danger fw-bold"
                      }
                    >
                      {isEligible ? "✅ ELIGIBLE" : "❌ NOT ELIGIBLE"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // ============== DASHBOARD DATA ==============
  const rawData = [
    {
      title: "Total Direct Associates",
      value: (
        <span
          style={{ color: dashboard.totalAssociate === 0 ? "red" : "green" }}
        >
          {dashboard.totalAssociate}
        </span>
      ),
      icon: "FaUserTie",
      href: "/my-associates",
    },
    {
      title: "Projects",
      value: (
        <span
          style={{ color: dashboard.activeProject === 0 ? "red" : "green" }}
        >
          {dashboard.activeProject}
        </span>
      ),
      icon: "FaBuilding",
      href: "/available-Project",
    },
    {
      title: "OnGoing Projects",
      value: (
        <span
          style={{ color: dashboard.ongoingProject === 0 ? "red" : "green" }}
        >
          {dashboard.ongoingProject}
        </span>
      ),
      icon: "FaTasks",
      href: "/all-project",
    },
    {
      title: "Completed Projects",
      value: (
        <span
          style={{ color: dashboard.completeProject === 0 ? "red" : "green" }}
        >
          {dashboard.completeProject}
        </span>
      ),
      icon: "FaCheckCircle",
      href: "/all-project",
    },
    {
      title: "Total 11 Level My Team",
      value: (
        <span
          style={{ color: dashboard.totalTeamCount === 0 ? "red" : "green" }}
        >
          {dashboard.totalTeamCount}
        </span>
      ),
      icon: "FaUsersCog",
      href: "/my-team",
    },
    {
      title: "Total Property Leads",
      value: (
        <span
          style={{ color: dashboard.total_property === 0 ? "red" : "green" }}
        >
          {dashboard.total_property}
        </span>
      ),
      icon: "FaBuilding",
      href: "/property-lead-list",
    },
    {
      title: "Total SQYD Channel Partner Sales",
      value: (
        <span
          style={{
            color:
              Number(dashboard.total_sqyd_channel_sales) === 0 ||
              !dashboard.total_sqyd_channel_sales
                ? "red"
                : "green",
          }}
        >
          {Number(dashboard.total_sqyd_channel_sales) > 0
            ? Number(dashboard.total_sqyd_channel_sales).toFixed(2)
            : "0.00"}
        </span>
      ),
      icon: "FaBuilding",
      href: "#",
    },
    {
      title: "Total Channel Partner Sales Earning",
      value: (
        <span
          style={{
            color:
              Number(dashboard.total_channel_sales_earning) === 0 ||
              !dashboard.total_channel_sales_earning
                ? "red"
                : "green",
          }}
        >
          {Number(dashboard.total_channel_sales_earning) > 0
            ? Number(dashboard.total_channel_sales_earning).toFixed(2)
            : "0.00"}
        </span>
      ),
      icon: "TbReceiptRupee",
      href: "#",
    },
    {
      title: "First Line (30%)",
      value: (
        <span
          style={{
            color: lineData.line1.total_buysqft === 0 ? "red" : "green",
          }}
        >
          {Number(lineData.line1.total_buysqft).toFixed(2)} SQYD
        </span>
      ),
      icon: "CiLineHeight",
      href: "/first-line",
    },
    {
      title: `Second Line (30%)`,
      value: (
        <span
          style={{
            color: lineData.line2.total_buysqft === 0 ? "red" : "green",
          }}
        >
          {Number(lineData.line2.total_buysqft).toFixed(2)} SQYD
        </span>
      ),
      icon: "CiLineHeight",
      href: "/second-line",
    },
    {
      title: "Third Line (40%)",
      value: (
        <span
          style={{
            color: lineData.line3.total_buysqft === 0 ? "red" : "green",
          }}
        >
          {Number(lineData.line3.total_buysqft).toFixed(2)} SQYD
        </span>
      ),
      icon: "CiLineHeight",
      href: "/third-line",
    },
    {
      title: "Welcome Bonus",
      icon: "FaGift",
      customContent: true,
      href: "/associates-bima-achiever-lists",
    },
    {
      title: "Bima",
      icon: "TbReceiptRupee",
      customContent: true,
      href: "/associates-welcome-bonus-achiever-lists",
    },
  ];

  const dashboardData = rawData.filter((item) => {
    if (
      userType === "channel" &&
      item.title === "Total Direct Associates Count"
    )
      return false;
    if (
      userType === "associate" &&
      (item.title === "Total Direct Channel Partners Count" ||
        item.title === "Total SQYD Channel Partner Sales" ||
        item.title === "Total Channel Partner Sales Earning")
    )
      return false;
    return true;
  });

  // ============== RENDER ==============
  return (
    <>
      {/* <div id="Breadcrumb" className="">
        <Row>
          <Col lg={3}>
            <h4 className="page-title mb-0">Dashboard</h4>
          </Col>
          <Col lg={6}>
            <div className="d-flex justify-content-center align-items-center">
              <h6
                className="designation_local mb-0"
                style={{ textDecoration: "underline" }}
              >
                {designation
                  ? `DESIGNATION - ${designation.toUpperCase()}`
                  : "NA"}
              </h6>
            </div>
          </Col>
          <Col lg={3}>
            <div className="d-none d-lg-block float-end">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </Col>
        </Row>
      </div> */}
{/* ═══════════ MODERN DASHBOARD HEADER ═══════════ */}
<div className="dashboard-page-header">
  <div className="d-flex align-items-center gap-3">
    <div className="dashboard-header-icon">
      <FaHome />
    </div>
    <div>
      <h2 className="dashboard-header-title">Dashboard</h2>
      <p className="dashboard-header-subtitle">
        Welcome back! Here's your overview
      </p>
    </div>
  </div>

  <div className="d-flex align-items-center gap-3 flex-wrap">
    <div className="designation-badge">
      <FaIdBadge className="designation-badge-icon" />
      <span>
        {designation ? `DESIGNATION - ${designation.toUpperCase()}` : "NA"}
      </span>
    </div>

    <nav className="breadcrumb-modern">
      <Link to="/dashboard" className="breadcrumb-link">
        <FaHome size={12} />
        <span>Home</span>
      </Link>
      <span className="breadcrumb-separator">/</span>
      <span className="breadcrumb-current">Dashboard</span>
    </nav>
  </div>
</div>

      {/* SLIDER — PREMIUM DESIGN */}
      <div
        className="slider-wrapper fade-in"
        style={{ height: "680px", minHeight: "680px" }}
      >
        {loading ? (
          <div className="loading-spinner">Loading...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : sliderImages.length > 0 ? (
          <>
            <img
              src={`${imageSlider}${sliderImages[currentSlide]?.image}`}
              alt={`Slide ${currentSlide + 1}`}
              className="slide-image"
            />

            <div className="slider-content">
              <div className="slider-text-block">
                <div className="slider-trusted-badge">
                  <span className="star-icon">★</span>
                  Trusted by 1000+ Families
                </div>

                <h1 className="slider-heading">
                  Find Your <span className="highlight">Dream Home</span>
                  <br />
                  In The Heart Of <span className="highlight">Jaipur</span>
                </h1>

                <p className="slider-subheading">
                  Explore premium residential and commercial properties with
                  complete transparency. Your trusted real estate partner for
                  over 15 years.
                </p>

                <div className="slider-actions">
                  <Link to="/available-Project" className="slider-btn-primary">
                    Explore Projects
                    <MdOutlineArrowForwardIos className="arrow-icon" />
                  </Link>

                  <button className="slider-btn-secondary" type="button">
                    <span className="play-icon">▶</span>
                    Watch Video
                  </button>
                </div>

                <div className="slider-trust-indicators">
                  <div className="slider-trust-item">
                    <span className="check-icon">✓</span>
                    RERA Approved
                  </div>
                  <div className="slider-trust-item">
                    <span className="check-icon">✓</span>
                    Legal Verified
                  </div>
                  <div className="slider-trust-item">
                    <span className="check-icon">✓</span>
                    Best Price
                  </div>
                </div>
              </div>
            </div>

            <div className="slider-stats-cards">
              <div className="slider-stat-card">
                <div className="slider-stat-icon yellow">🏢</div>
                <div className="slider-stat-info">
                  <div className="slider-stat-value">500+</div>
                  <div className="slider-stat-label">Projects</div>
                </div>
              </div>

              <div className="slider-stat-card">
                <div className="slider-stat-icon orange">👥</div>
                <div className="slider-stat-info">
                  <div className="slider-stat-value">1000+</div>
                  <div className="slider-stat-label">Happy Clients</div>
                </div>
              </div>
            </div>

            <div className="slider-dots">
              {sliderImages.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  className={`slider-dot ${idx === currentSlide ? "active" : ""}`}
                  onClick={() => setCurrentSlide(idx)}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>

            <div className="controls">
              <div className="buttonalldesignnew">
                <button
                  type="button"
                  className="left"
                  onClick={() =>
                    setCurrentSlide(
                      (prev) =>
                        (prev - 1 + sliderImages.length) % sliderImages.length,
                    )
                  }
                >
                  <MdOutlineArrowBackIos />
                </button>
              </div>
              <div className="buttonalldesignnew">
                <button
                  type="button"
                  className="right"
                  onClick={() =>
                    setCurrentSlide((prev) => (prev + 1) % sliderImages.length)
                  }
                >
                  <MdOutlineArrowForwardIos />
                </button>
              </div>
            </div>
          </>
        ) : (
          <NoDataMessage message="Sorry, no slider images found" />
        )}
      </div>

      {/* DASHBOARD CARDS */}
      <Row className="mt-4">
        {dashboardData.length > 0 ? (
          dashboardData.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            if (item.customContent && item.title === "Welcome Bonus") {
              const bonusData = dashboard?.bonus || {};
              const joiningDate = bonusData.joiningDate || "--";
              const lastDate = bonusData.lastDate || "--";
              const leadDate = bonusData.leadDate || "--";
              const targetDate = bonusData.targetDate || "--";
              const approveDate = bonusData.approveDate || "--";
              const approved = bonusData.approved || false;
              const isValidDate = (date) => {
                return (
                  date && date !== "--" && date !== null && date !== "null"
                );
              };
              const isDateExpired = (dateStr) => {
                if (!isValidDate(dateStr)) return true;
                const currentDate = new Date();
                const [day, month, year] = dateStr.split("-");
                const dateObj = new Date(year, month - 1, day);
                return currentDate > dateObj;
              };
              let joiningBookingStatus = "--";
              let joiningBookingColor = "#6c757d";
              let canRegister = false;
              if (isValidDate(joiningDate) && isValidDate(lastDate)) {
                if (approved === true) {
                  joiningBookingStatus = "Success";
                  joiningBookingColor = "#28a745";
                  canRegister = false;
                } else if (approved === false) {
                  if (!isDateExpired(lastDate)) {
                    joiningBookingStatus = "Progress";
                    joiningBookingColor = "#ffc107";
                    canRegister = true;
                  } else {
                    joiningBookingStatus = "Progress";
                    joiningBookingColor = "#ffc107";
                    canRegister = false;
                  }
                }
              } else {
                joiningBookingStatus = "Not Available";
                joiningBookingColor = "#dc3545";
                canRegister = false;
              }
              let bookingClosingStatus = "--";
              let bookingClosingColor = "#6c757d";

              if (isValidDate(leadDate) && isValidDate(targetDate)) {
                if (approved === true && isValidDate(approveDate)) {
                  bookingClosingStatus = "Achieved";
                  bookingClosingColor = "#28a745";
                } else {
                  bookingClosingStatus = "Not Achieved";
                  bookingClosingColor = "#dc3545";
                }
              } else {
                bookingClosingStatus = "Not Achieved";
                bookingClosingColor = "#dc3545";
              }
              const formatDisplayDate = (dateStr) => {
                if (
                  !dateStr ||
                  dateStr === "--" ||
                  dateStr === null ||
                  dateStr === "null"
                )
                  return "--";
                return dateStr;
              };
              const handleCardClick = () => {
                const fullUrl = `/welcome-bonus-registration-form`;
                navigate(fullUrl);
              };

              return (
                <Col key={index} xs={12} sm={6} md={6} lg={6}>
                  <div
                    className="card bg_card_design welcome-bonus-card h-100"
                    style={{ cursor: "pointer" }}
                    onClick={handleCardClick}
                  >
                    <div className="card-body">
                      <div className="d-flex align-items-center gap-2 gap-md-4">
                        <div className="icon_dashboard">
                          <FaGift size={40} className="text-white" />
                        </div>
                        <div className="w-100">
                          <div className="card-title mb-0">{item.title}</div>
                          <div className="d-flex justify-content-between mt-2">
                            <div className="date-section">
                              <div className="date-label">
                                Joining + Booking
                              </div>
                              <div className="date-range">
                                {formatDisplayDate(joiningDate)} -{" "}
                                {formatDisplayDate(lastDate)}
                              </div>
                              {joiningBookingStatus !== "--" && (
                                <div
                                  className="status-badge"
                                  style={{ color: joiningBookingColor }}
                                >
                                  {joiningBookingStatus}
                                </div>
                              )}
                            </div>

                            <div className="date-section">
                              <div className="date-label">
                                Booking + Closing
                              </div>
                              <div className="date-range">
                                {formatDisplayDate(leadDate)} -{" "}
                                {formatDisplayDate(targetDate)}
                              </div>
                              {bookingClosingStatus !== "--" && (
                                <div
                                  className="status-badge"
                                  style={{ color: bookingClosingColor }}
                                >
                                  {bookingClosingStatus}
                                </div>
                              )}
                            </div>
                          </div>

                          {canRegister && (
                            <div
                              className="register-text mt-2"
                              style={{
                                color: "#17a2b8",
                                fontSize: "14px",
                                textAlign: "center",
                              }}
                            >
                              Click to Register
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            }

            if (item.customContent && item.title === "Bima") {
              const { activeStatus, successStatus } = dashboard.bimaStatus;
              let statusText = "Inactive";
              let statusColor = "#dc3545";
              let canRegister = false;
              let bimaImage = runningHourse;

              if (activeStatus === true && successStatus === true) {
                statusText = "Success";
                statusColor = "#28a745";
                canRegister = false;
                bimaImage = bimaSuccessImg;
              } else if (activeStatus === true && successStatus === false) {
                statusText = "Active";
                statusColor = "#28a745";
                canRegister = true;
                bimaImage = bimaActiveImg;
              } else {
                statusText = "Inactive";
                statusColor = "#dc3545";
                canRegister = false;
                bimaImage = runningHourse;
              }

              const handleBimaClick = () => {
                navigate("/bima-registration-form");
              };

              return (
                <Col key={index} xs={12} sm={6} md={6} lg={6}>
                  <div
                    className="card bg_card_design welcome-bonus-card h-100"
                    style={{ cursor: "pointer" }}
                    onClick={handleBimaClick}
                  >
                    <div className="card-body">
                      <div className="d-flex align-items-center gap-2 gap-md-4">
                        <div className="icon_dashboard bg_running">
                          <img
                            src={bimaImage}
                            alt="bima"
                            className="load_img hourse"
                          />
                        </div>
                        <div className="d-flex align-items-start justify-content-between flex-column w-100">
                          <div className="card-title mb-0">{item.title}</div>
                          <div className="d-flex justify-content-between align-items-center w-100 mt-2">
                            <div
                              className="fw-bold"
                              style={{ color: statusColor, fontSize: "18px" }}
                            >
                              {statusText}
                            </div>
                            {canRegister && (
                              <div
                                className="register-text"
                                style={{ color: "#17a2b8", fontSize: "14px" }}
                              >
                                Click to Register
                              </div>
                            )}
                            {!canRegister && statusText === "Success" && (
                              <div
                                className="register-text"
                                style={{ color: "#28a745", fontSize: "14px" }}
                              >
                                Claimed
                              </div>
                            )}
                            {!canRegister && statusText === "Inactive" && (
                              <div
                                className="register-text"
                                style={{ color: "#dc3545", fontSize: "14px" }}
                              >
                                Not Available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            }

            return (
              <Col key={index} xs={12} sm={6} md={4} lg={4}>
                <div className="card bg_card_design">
                  <Link to={item.href} className="text-decoration-none">
                    <div className="card-body pr-0 gap-2 d-flex align-items-center justify-content-start">
                      {IconComponent && (
                        <div className="icon_dashboard">
                          <IconComponent size={40} className="text-white" />
                        </div>
                      )}
                      <div>
                        <div className="card-title">{item.title}</div>
                        <div className="card-text">
                          {item.value
                            ? item.value
                            : item.image && (
                                <img
                                  className="load_img hourse"
                                  src={item.image}
                                  alt="load-img"
                                />
                              )}
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </Col>
            );
          })
        ) : (
          <NoDataMessage message="Sorry, no dashboard data found" />
        )}
      </Row>

      {/* GIFT PROGRESS */}
      <div className="card mt-4">
        <div className="card-body shadow-none">
          <GiftProgressBar />
        </div>
      </div>

      {/* TEAM PROGRESS */}
      <div className="card mt-4">
        <div className="card-body shadow-none">
          <TeamProgressBar />
        </div>
      </div>

      {/* LIFETIME REWARDS */}
      <div className="card mt-4">
        <div className="card-body shadow-none">
          <LifetimeRewardsProgressBar />
        </div>
      </div>

      {/* ROYALTY REWARDS */}
      <div className="card mt-4">
        <div className="card-body shadow-none">
          <RoyaltyRewardsProgressBar />
        </div>
      </div>
    </>
  );
};

export default Dashboard;